export { Textarea, type TextareaProps } from './Textarea';
export {
  textareaVariants,
  type TextareaVariantProps,
} from './textarea.variants';
